import React, { useState, useRef, useEffect } from "react";
import { Stack, TextField, Button, Divider,FormControl } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { useTranslation } from "react-i18next";
import ItemPropertiesDelimiterInput from '../../../ItemProperties/ItemPropertiesDelimiterInput'
import { useDispatch,useSelector } from "react-redux";
import { newTemplateActions } from "../../../../redux/slices/newTemplateSlice";
function NtwDelimitedHeaderTemplate() {
  const { t } = useTranslation();
  const error = useRef();
  const fileBrowser = useRef();
  const dispatch = useDispatch();
  const {DelimitedHeaderData} = useSelector(state => state.newTemplate)

  const [delimitedHeaderFileVal, setDelimitedHeaderFileVal] = useState("");
  const [csvData,setCsvData] = useState('')
  const [fieldDelimiter, setFieldDelimiter] = useState('');
  const [recordDelimiter,setRecordDelimiter] = useState('')
  const newTemplate = useSelector(state => state.newTemplate)

  const handleUploadClick = (e) => {
    const file = e.target.files[0];
    setDelimitedHeaderFileVal(file.name)
    const fileNameWithoutExtension = file.name.split('.').slice(0,-1).join('.')
    dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension))
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileInfo = e.target.result;
          dispatch(newTemplateActions.setDelimitedHeaderData({ ...DelimitedHeaderData,fileInfo }));
        };
        reader.readAsText(file);
      }
  };
  const handlePaste = (e) =>{
   const val = e.target.value;
   setCsvData(val);
   if(!newTemplate?.DelimitedHeaderData?.hasOwnProperty('fileInfo')) dispatch(newTemplateActions.setDelimitedHeaderData({...DelimitedHeaderData,data:val}))
  }
  
  useEffect(() => {
    dispatch(newTemplateActions.setIsFormData(true));
    setFieldDelimiter(DelimitedHeaderData.FIELD_DELIMITER);
    setRecordDelimiter(DelimitedHeaderData.RECORD_DELIMITER);
  }, []);

  return (
    <>
      <div className="flex" style={{flexDirection:'column'}}>
        <div className="flex">
          <TextField
            className="width-100"
            label={t("Choose CSV File")}
            variant="outlined"
            size="small"
            value={delimitedHeaderFileVal}
            onChange={(e) => {
              error.current.textContent = "";
            }}></TextField>
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setDelimitedHeaderFileVal(e.target.value);
              error.current.textContent = "";
              handleUploadClick(e);
            }}
          />
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
            <DriveFolderUploadIcon fontSize="small" />
          </Button>
        </div>
        <div>
          <p className="error" ref={error}></p>
        </div>
        <Divider sx={{marginBottom:'8px', marginTop: "8px"}}>{t("OR")}</Divider>
        <div style={{display:'flex',flexDirection:'column',gap:'7px'}}>
         <div style={{width:'100%',marginBottom:'10px',flex:1}}>
          <TextField
            variant="outlined"
            className="width-100"
            size="small"
            label={t("TXT_PASTE_CSV_TEMPLATE_DATA_HERE")}
            maxRows={6}
            minRows={4}
            multiline
            value={csvData}
            onChange={(e) => {
              handlePaste(e);
            }}
          />
         </div>
        <div className="flex" style={{flex:1}}>
          <FormControl className="width-100" size="small" style={{flex:1,marginRight:'10px'}}>
            <ItemPropertiesDelimiterInput
              label={t("LBL_FLD_DELIM")}
              name={"FIELD_DELIMITER"}
              value={fieldDelimiter}
              source={'NTW'}
            />
          </FormControl>
          <FormControl className="width-100" size="small" style={{flex:1}}>
            <ItemPropertiesDelimiterInput
              label={t("LBL_REC_DELIM")}
              name={"RECORD_DELIMITER"}
              value={recordDelimiter}
              source={'NTW'}
            />
          </FormControl>
          </div>
        </div>
        </div>
    </>
  );
}

export default NtwDelimitedHeaderTemplate;
